import { createSlice } from "@reduxjs/toolkit";
import {
  getTvNews,
  getTvNewsStats,
  planTvNews,
  stopTvNews,
  deleteTvNews,
} from "./thunk";
import { readThunkError } from "../thunkError";

export const initialState = {
  recordings: [],
  total: 0,
  stats: null,
  loading: false,
  error: {},
};

const tvNewsSlice = createSlice({
  name: "tvnews",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTvNews.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getTvNews.fulfilled, (state, action) => {
      state.recordings = (action.payload && action.payload.items) || [];
      state.total = (action.payload && action.payload.total) || 0;
      state.loading = false;
      state.isSuccess = true;
    });

    builder.addCase(getTvNews.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.loading = false;
      state.isSuccess = false;
    });

    builder.addCase(getTvNewsStats.fulfilled, (state, action) => {
      state.stats = action.payload;
    });

    builder.addCase(getTvNewsStats.rejected, (state, action) => {
      state.error = readThunkError(action);
    });

    builder.addCase(deleteTvNews.fulfilled, (state, action) => {
      state.recordings = (state.recordings || []).filter(
        (r) => r._id.toString() !== action.payload.id.toString()
      );
      state.total = Math.max(0, state.total - 1);
    });

    builder.addCase(planTvNews.rejected, (state, action) => {
      state.error = readThunkError(action);
    });

    builder.addCase(stopTvNews.rejected, (state, action) => {
      state.error = readThunkError(action);
    });
  },
});

export default tvNewsSlice.reducer;
